<template>
    <label class="consent-checkbox">
        <input type="checkbox" :checked="value" @input="emitChange" :required="required" :name="name">
    </label>
</template>

<script setup>
const { value, required, name } = defineProps({
    value: {
        type: Boolean,
        default: false
    },
    required: {
        type: Boolean,
        default: false
    },
    name: {
        type: String,
    },
});
const emit = defineEmits(['input'])

function emitChange(event) {
    emit('input', event.target.checked)
}

</script>

<style lang="sass" scoped>
.consent-checkbox
    --size: 24px
    display: flex
    justify-content: center
    align-items: center

    max-width: var(--size)
    min-width: var(--size)
    max-height: var(--size)
    min-height: var(--size)

    border: 1px solid white
    border-radius: 5px

    cursor: pointer

    &:has(input:checked)
        &::after
            content: url("data:image/svg+xml,%3Csvg width='15' height='12' viewBox='0 0 15 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.14641 11.2071L14.1464 2.20711C14.5369 1.81658 14.5369 1.18342 14.1464 0.792893C13.7559 0.402369 13.1227 0.402369 12.7322 0.792893L5.14641 8.37868L1.91414 5.14641C1.52361 4.75588 0.890449 4.75588 0.499924 5.14641C0.1094 5.53693 0.1094 6.1701 0.499924 6.56062L3.7322 9.79289L4.08571 10.1464C4.08592 10.1466 4.08613 10.1468 4.08633 10.147L5.14641 11.2071Z' fill='white'/%3E%3C/svg%3E%0A")
            width: 100%
            height: 100%
            display: flex
            justify-content: center
            align-items: center

    input
        position: absolute
        opacity: 0
        width: var(--size)
        height: var(--size)
</style>
